import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "vueBreadcrumbWrapper container-fluid border-bottom px-0 white-bg" };
const _hoisted_2 = { class: "container" };
const _hoisted_3 = { class: "breadcrumb mb-0 py-1" };
const _hoisted_4 = { class: "col-12 pl-0 fc-brand_deep_blue" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("a", {
    href: "/",
    class: "p-1 m-1 text-underline",
    title: "Home"
}, "Home", -1);
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("i", { class: "icon-arrow-next" }, null, -1);
const _hoisted_7 = ["href", "title"];
const _hoisted_8 = {
    key: 0,
    class: "d-inline-block"
};
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("i", { class: "icon-arrow-next" }, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a, _b;
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_a = _ctx.currentProduct) === null || _a === void 0 ? void 0 : _a.breadcrumb, (entry, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                            class: "d-inline-block",
                            key: index
                        }, [
                            _hoisted_6,
                            _createElementVNode("a", {
                                href: entry[0],
                                class: "p-1 m-1 text-underline",
                                title: entry[0]
                            }, _toDisplayString(entry[1]), 9, _hoisted_7)
                        ]));
                    }), 128)),
                    (!_ctx.isMobile)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _hoisted_9,
                            _createElementVNode("span", null, _toDisplayString((_b = _ctx.currentProduct) === null || _b === void 0 ? void 0 : _b.name), 1)
                        ]))
                        : _createCommentVNode("", true)
                ])
            ])
        ])
    ]));
}
